/**
 * Couleurs sémantiques et presets (usage JS / conditions).
 * Les variables CSS du design system restent dans GlobalStyles.jsx.
 */

export const COLOR_ACCENT_DEFAULT = "#B8FF47";
export const COLOR_BG_DEFAULT = "#07080A";

/** Thème par défaut (aligné design system) */
export const DEF_THEME = { bg: COLOR_BG_DEFAULT, accent: COLOR_ACCENT_DEFAULT };

export const BG_PRESETS = ["#020617", "#020817", "#030712", "#0B1120", "#111827", "#0F172A"];

export const SETTINGS_BG_PRESETS = [
  "#07080A",
  "#0D0D0D",
  "#0A0F1E",
  "#0F0A1A",
  "#0A1A0F",
  "#1A100A",
  "#FFFFFF",
];

export const ACCENT_PRESETS = [
  "#B8FF47",
  "#FF6B6B",
  "#4ECDC4",
  "#FFE66D",
  "#A855F7",
  "#F97316",
  "#3B82F6",
  "#EC4899",
];

/** Couleurs statuts client (badges, légendes) */
export const CLIENT_STATUS_COLORS = {
  active: "#B8FF47",
  standby: "#FFB547",
  archived: "#7A8494",
};
